import { AxiosResponse } from 'axios'
import hosts from 'config/microServices'
import IModoCompactoConfig from 'Models/docas/IModoCompactoConfig'
import IVeiculoTransportadora from 'Models/docas/IVeiculoTransportadora'
import ApiService from 'Services/ApiService'
import {
  ServiceCreateResponse,
  ServiceListResponse,
  ServiceUpdateResponse,
} from 'Types/ServiceResponse'

const veiculo = {
  buscaVeiculo: async (
    idComponente: number,
    placa: string,
    cdTransportadora: number,
  ): Promise<IVeiculoTransportadora | undefined> => {
    const result: AxiosResponse<ServiceListResponse<IVeiculoTransportadora>> =
      await ApiService({
        idComponente,
      }).get<ServiceListResponse<IVeiculoTransportadora>>(
        `${hosts.WS_DOCAS}/veiculo?placa=${placa}&cdTransportadora=${cdTransportadora}`,
      )

    return result.data.item
  },

  criaVeiculo: async (
    idComponente: number,
    placa: string,
    cdTransportadora: number,
  ): Promise<IVeiculoTransportadora | undefined> => {
    const result: AxiosResponse<ServiceListResponse<IVeiculoTransportadora>> =
      await ApiService({
        idComponente,
      }).post<ServiceListResponse<IVeiculoTransportadora>>(
        `${hosts.WS_DOCAS}/veiculo`,
        {
          placa,
          cdTransportadora,
        },
      )

    return result.data.item
  },
}

export default veiculo
